export const restrictedApparentPower = 0.8;
export const restrictedNominalPower = 2.0;
